// extracted by mini-css-extract-plugin
export default {"imgdiv":"_163cfe3317 _3d5d17b254","img":"d799a0e5f6 _63e66d8411"};